import ActionComponent from 'components/ActionComponent'
import { groupBy, keys, minBy, range } from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import Axis from '../../../components/echart/Axis'
import EChart from '../../../components/echart/EChart'
import Bar from '../../../components/echart/series/Bar'
import { getYear } from '../../../utils/DateUtil'
import { getMapStateToProps, getPropType, getPropTypes } from '../../../utils/StoreUtils'
import { COLOR_BY_TYPE, getEventTypeInfo } from 'events/utils/EventUtils'

const storeProps = {
}

const UNKNOWN_COLOR = 'grey'

class EventVisitsBarChart extends ActionComponent {
    render() {
        const minDate = minBy(this.props.events, 'date')
        const minYear = minDate && (getYear(minDate.date) < getYear(moment()) - 10) ? getYear(minDate.date) : getYear(moment()) - 10
        const yearRange = range(minYear, getYear(moment()) + 1)

        const eventTypeInfo = getEventTypeInfo()
        const eventsByType = groupBy(this.props.events, 'eventType')
        const eventTypes = keys(eventsByType).sort()

        const series = eventTypes.map(eventType => {
            const color = COLOR_BY_TYPE[eventType] || UNKNOWN_COLOR
            const label = eventTypeInfo[eventType] ? eventTypeInfo[eventType].label : i18n.undefinedIntervention
            const eventsByYear = groupBy(eventsByType[eventType], e => getYear(e.date))

            const data = yearRange.map(year => ({
                name: year,
                value: eventsByYear[year] ? eventsByYear[year].length : 0,
                itemStyle: {
                    normal: { color },
                    emphasis: { color },
                },
            }))

            return Bar({
                data,
                name: label,
            })
        })

        const options = {
            series,
            tooltip: {
                trigger: 'item',
            },
            yAxis: [Axis({
                type: 'value',
            })],
            xAxis: [Axis({
                type: 'category',
                data: yearRange,
                axisLabel: {
                    fontSize: 10,
                },
            })],
            height: 150,
            gridHeight: 140,
        }
        return (
            <div className='row no-margin'>
                <EChart options={ options } />
            </div>
        )
    }
}

EventVisitsBarChart.propTypes = getPropTypes(storeProps, {
    events: getPropType('stationEvents'),
    previsionalVisitNumber: PropTypes.number,
})

const mapStateToProps = () => getMapStateToProps(storeProps, {
})

export default connect(mapStateToProps)(EventVisitsBarChart)